export const _LOAD_MODEL_ = 'Load:CustomerModel';
export const _OPEN_MODAL_ = 'Open:FileCustomer';
export const _DELETE_CUSTOMER_ = 'Delete:Customer';
export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';
export const _SAVE_CUSTOMER_SUCCESS_ = 'Save:CustomerSuccess';
export const _SAVE_FILE_SUCCESS_ = 'Save:FileSuccess';

export const MODAL_TYPE = 'send_message_new_files_upload_modal';

export const ADDRESS = {
  id: null,
  city: '',
  label: 'Endereço Principal',
  state: '',
  number: '',
  street: '',
  address: '',
  country: 'BR',
  zipcode: '',
  address2: null,
  district: '',
};

export const CONTACT = {
  id: null,
  name: '',
  email: '',
  phone: '',
};

export const MODEL = {
  id: null,
  name: '',
  type: 'individual',
  email: '',
  phone: '',
  comment: '',
  document: '',
  contact: { ...CONTACT },
  addresses: [{ ...ADDRESS }],
};
